module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'form-group': true,
      'has-error': this.m_error !== null
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.field.label))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.m_fieldAnswer.value),
      expression: "m_fieldAnswer.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Preencha o campo",
      "disabled": _vm.disabledAttribute
    },
    domProps: {
      "value": (_vm.m_fieldAnswer.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.m_fieldAnswer, "value", $event.target.value)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f8fb2a3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/quizzes/questions/fields/StringField.vue
// module id = 699
// module chunks = 1